export default function(instance){
    return{
        getAllCatalogRequestConfig(){
            return instance.get('/catalogRequestConfig');
        },  
    }
}